import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  year: number;
  category: string;
  rating: number;
  poster: string;
  categoryName?: string;
}

export default function MovieCard({ id, title, year, rating, poster, categoryName }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={poster}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          title={`${title} - 神马影院高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <div className="w-10 h-10 mx-auto flex items-center justify-center bg-primary-500 rounded-full">
            <i className="ri-play-fill text-white text-lg"></i>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{year}</span>
          {categoryName && (
            <>
              <span className="text-foreground-300">|</span>
              <span>{categoryName}</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}